"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OsmosysFormSlugField_1 = require("./OsmosysFormSlugField");
const OsmosysResourceSlugField_1 = require("./OsmosysResourceSlugField");
exports.OsmosysSlugField = (props) => {
    if ('resource' in props) {
        return react_1.default.createElement(OsmosysResourceSlugField_1.OsmosysResourceSlugField, Object.assign({}, props));
    }
    return react_1.default.createElement(OsmosysFormSlugField_1.OsmosysFormSlugField, Object.assign({}, props));
};
//# sourceMappingURL=OsmosysSlugField.js.map